import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
	state: {
		excel_data: '',
		prefectures_data:[],
		municipality_data: [],

		selected_prefectures:'',
		selected_municipality:'',
		result_shopList:[],

		excel_item_master:[
			'県名',
			'販売店名',
			'郵便番号',
			'住所',
			'TEL',
			'FAX',
			'URL',
			'E-Mail',
			'営業時間',
			'定休日',
			'交通機関',
			'駐車場',
			'お店のPR',
			'表示状態'
		]
	},
	getters: {
		excel_data(state){
			return state.excel_data;
		},
		selected_prefectures(state){
			return state.selected_prefectures;
		},
		selected_municipality(state){
			return state.selected_municipality;
		},
		result_shopList(state){
			return state.result_shopList;
		},
	},
	mutations: {
		//setExcelData(state, data) { state.excel_data = data },
		setExcelData(state, data) {
			let return_array = [];
			for(let i in data){
				if(data[i]['表示状態'] === 0 ){
					return_array.push(data[i]);
				}
			}
			state.excel_data = return_array;
		},
		setPrefecturesData(state, data) {
			let return_array = [];
			for(let i in data){
				let name = data[i]['都道府県'];
				return_array[name] = {lat:data[i]['lat'], lng:data[i]['lng']}
			}
			state.prefectures_data = return_array;
		},
		setMunicipalityData(state, data) {
			let return_array = [];
			for(let i in data){
				let name = data[i]['都道府県'];
				if(!return_array[name]){
					return_array[name] = [];
				}
				if(data[i]['表示状態'] == 0){
					return_array[name].push(data[i]['市区町村']);
				}
			}
			state.municipality_data = return_array;
		},
		SET_PREF(state, data){
			state.selected_prefectures = data;
		},
		SET_MUNI(state, data){
			state.selected_municipality = data;
		},
		SET_RESULT_SHOPLIST(state, data){
			state.result_shopList = data;
		}
	},
})
